<template>
  <el-row :gutter="20" class="footerM">
    <el-col :span="12" class="item yuyue">
      <i v-show="!yuyue" class="el-icon-star-off yuyue"></i>
      <i v-show="yuyue" class="el-icon-star-on yuyue"></i>
      <span>展览预约</span>
    </el-col>
    <el-col :span="12" class="item">
      <i v-show="!my" class="el-icon-user me"></i>
      <i v-show="my" class="el-icon-user-solid me"></i>
      <span>我的</span>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data () {
    return {
      my: false,
      yuyue: true
    }
  }
}
</script>
<style lang="less" scoped>
.footerM {
  height: 50px;
  border-top: 1px solid #ccc;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    .yuyue {
      font-size: 25px;
    }
    .me {
      font-size: 20px;
    }
    span {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tab/footerMobile.vue